// prettier-ignore
export default "2025.0804.0818"